export default __webpack_public_path__ + "static/media/ico_csv_grey.38a88704.svg";